import { useMutation, useQueryClient } from "react-query";

import { crearMandante, updateMandante, deleteMandante} from '../../services/Mandantes';

import { toast } from 'react-hot-toast';
const queryKey = "sucursal";

export const useMandanteMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addMandante = useMutation((body) => crearMandante(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
  const updateMandanteD = useMutation(
    (body) => updateMandante( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeMandante = useMutation((id) => deleteMandante( id), {
    onSuccess,
    onError,
  });

  return { addMandante, updateMandanteD, removeMandante };
};
export default useMandanteMutations;